export default function PrevisionnelTourneeConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('previsionnel.tournee');
}

PrevisionnelTourneeConfiguration.$inject = ['$translatePartialLoaderProvider'];
